import React from 'react'
import { BiLinkExternal } from 'react-icons/bi'
import { Link } from 'react-router-dom'
import moment from 'moment'

import './statuspage-demo.css'
import { componentStatus, pageTopLevelStatus } from '../../Constants/Constants'
import { BarChartDemo } from '../../Components'

/**
 * 
 * @returns 
 */
export function StatusPageContentDemo({ 
    name ,
    url ,
    logo ='' ,
    background_color = null ,
    header_text_color = null ,
    components
}) {

	return (
		<div className='layout status-index'>
			<Header  pageData={{
				website_url : url ?? "https://statusway.co",
				support_url : url ?? "https://statusway.co",
				name  : name,
				logo  : logo,
				status : "ALL-SYSTEMS-OPERATIONAL",
                background_color : background_color ,
                header_text_color : header_text_color ,
			}} />
			<div className='components-section'>
				<div className="container card">
					<div className="component-items">

					{
						components?.map( ( component , index) => {
							return (
								<ComponentItem key={index} component={component} />
							)
						})
					}
					</div>
				</div>
			</div>
			<div className="incidents-section last-incidents"></div>
		</div>
	)
}

const ComponentItem = ({ component }) => {

	//console.log(component)
    const componentStatusContent = componentStatus?.find( x => x.value === component?.status )


	return (
		<div  className="component-item">
			<div className="component-inner">
				<div className="component-name">{
                    component?.hideName === true 
                    ? <span className='anonymous-name'></span>
                    : component?.name
                }</div>
				<div className={`component-status ${componentStatusContent?.color_name}`}>{componentStatusContent?.label}</div>   
				{
					component?.display_chart === true && 
					<div className="uptime-chart uptime-90days">
						<BarChartDemo 
							id={component?.id}
							data={{}}
							period={60}
							tooltip={false}
							/>
						<div className="legend legend-date-range">
							<div className="legend-item legend-date"><span>{60}</span> days ago</div>
							<div className="space"></div>
							<div className="legend-item legend-uptime-value"><span className='uptime-value'>{100}</span>% uptime</div>
							<div className="space"></div>
							<div className="legend-item legend-date">Today</div>
						</div>
					</div>
				}
			</div>											
		</div>
	)
}

/**
 * 
 * @param {*} param0 
 * @returns 
 */
function Header({ pageData , children }) {

    let menuItems = [];
    if(pageData?.website_url !=='' && pageData?.name !=='') menuItems.push({ name : `Go to ${pageData?.name}` , link : pageData?.website_url , externalLink : true })
    if(pageData?.support_url !=='') menuItems.push({ name : `Support` , link : pageData?.support_url , externalLink : true })
	
	return (
		<div className='header' 
            style={{ backgroundColor : pageData?.background_color ?? '#0013ce'}} >
			<Navbar
				name={pageData?.name} 
				logo={pageData?.logo}
				menu={menuItems}
                textColor={pageData?.header_text_color ?? '#ffffff'}
				/>
            <TopLevelStatus 
                status={pageData?.status}
            />
			{ children }
		</div>
	)
}

/**
 * 
 * @param {*} param0 
 * @returns 
 */
function TopLevelStatus({ status , children }) {

	const selectedStatus = pageTopLevelStatus?.find( x => x.value === status )

	return (
		<div className="main_banner-wrapper" >
			<div className="container">
				<div className="toplevelstatus card">
					<div className="status--icon">
						<AnimatedCircleStatus 
							status={ selectedStatus?.color ?? 'orange'}
							title={``}
							size={`medium`}
						/>
					</div>
					<div className="status--tx-content">
						<div className="status--title">Current status</div>
						<div className="status--global_state_vl">{ selectedStatus?.label }</div>
						<div className="status--current_time">{ `As of ${moment().format('DD MMMM YYYY, hh:mm A')}` }</div>
					</div>
				</div>
			</div>
		</div>
	)
}

/**
 * 
 * @param {*} param0 
 * @returns 
 */
function Navbar({ name, logo , menu , textColor , children }) {

  return (
	<div className='navbar'>
		<div className="container">
			<div className="logo">
				<Link to="/" >
                    {
                        logo !=='' 
                        ? <img src={logo} />
                        :  <div className='logo-demo' ></div>
                    }					
				</Link>
			</div>
			<div className="menu">
				{
					menu?.length > 0 && 
					<ul>
						{
							menu?.map( (menuItem , index ) => {
								return (
									<li key={index}>
                                        {
                                            menuItem?.externalLink === true
                                            ? <a className="light" style={{ color : textColor }} href={menuItem?.link} target="_blanc" ><BiLinkExternal /> <span>{`${menuItem?.name}`}</span></a>
                                            : <Link className="light" style={{ color : textColor }} to={menuItem?.link}><a><span>{`${menuItem?.name}`}</span></a></Link>
                                        }
									</li>
									
								)
							})
						}
					</ul>
				}
			</div>
		</div>
	</div>
  )
}

function AnimatedCircleStatus(props) {

	const status = (typeof props.status !=='undefined' && ['red' , 'yellow' , 'orange', 'blue' ,'green'].includes(props.status))? props.status : 'none';
	const title = (typeof props.title !=='undefined' && props.title!=='')? props.title : '';
	const size = (typeof props.size !=='undefined' && props.size!==null && ['xsmall' , 'small' ,  'medium' , 'big'].includes(props.size)) ? props.size : 'small';

	const sizeIds = {
		xsmall : 'xs',
		small : 'sm',
		medium : 'md',
		big : 'bg',
	}

	return (
		<div 
			data-variation={status} 
			data-status="" 
			className={`status-indicator status-indicator--${status} status-indicator--${sizeIds[size]}  status-indicator--infinite` }
			data-last-checked-at="" 
			data-frequency="" 
			title={title}
			{ ...props}
			>
			<div className={`circle ${status !=='none' ? 'circle--animated' : ''} circle-main`}></div>
			<div className={`circle ${status !=='none' ? 'circle--animated' : ''} circle-secondary`}></div>
			<div className={`circle ${status !=='none' ? 'circle--animated' : ''} circle-tertiary`}></div>
		</div>
	)
}


